import React from 'react';
import clsx from 'clsx';
import {Link, Route, Switch, useHistory} from 'react-router-dom';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {default as MuiDrawer} from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {default as MuiLink} from '@material-ui/core/Link';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import dashboardRoutes from '../../../constants/dashboardRoutes';
import config from '../../../constants/config.json';
import Auth from '../../../utils/auth';
import Button from "@material-ui/core/Button";
import Home from "../../../views/Home/Home";
import PrivateRoute from "../PrivateRoute/PrivateRoute";
import Dashboard from "../../../views/Dashboard/Dashboard";
import Quota from "../../../views/Quota/Quota";
import Profile from "../../../views/Profile/Profile";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    title: {
        flexGrow: 1,
        fontWeight: "bold"
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
}));

const Hoc = ({children}) => {
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = React.useState(true);
    const history = useHistory();

    const signOut = () => {
        Auth.signOut()
            .then(() => {
                history.push('/')
            })
    }

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, open && classes.hide)}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        Espace utilisateur {config.app.name}
                    </Typography>
                    {Auth.isAuthenticated() && <Button onClick={signOut}>Se déconnecter</Button>}
                </Toolbar>
            </AppBar>
            <MuiDrawer
                className={classes.drawer}
                variant="persistent"
                anchor="left"
                open={open}
                classes={{
                    paper: classes.drawerPaper,
                }}
            >
                <div className={classes.drawerHeader}>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </div>
                <Divider />
                <List>
                    {dashboardRoutes.map((route, index) => (
                        !route.disabled ?
                            <Link to={route.path}>
                                <ListItem button key={`route-${route.name}`}>
                                    <MuiLink variant="inherit">
                                        {route.name}
                                    </MuiLink>
                                </ListItem>
                            </Link>
                            :
                            <ListItem button disabled key={`route-${route.name}`}>
                                <MuiLink variant="inherit">
                                    {route.name}
                                </MuiLink>
                            </ListItem>
                    ))}
                </List>
            </MuiDrawer>
            <main
                className={clsx(classes.content, {
                    [classes.contentShift]: open,
                })}
            >
                <div className={classes.drawerHeader} />

                {dashboardRoutes.map((route, index) => (
                    <PrivateRoute path={route.path}>
                        {route.component}
                    </PrivateRoute>
                ))}

            </main>
        </div>
    );
}

export default Hoc;